import confetti from "canvas-confetti";

// CertainPath brand palette (plus white/gold accents) for on-brand confetti.
const BRAND_COLORS = ["#B21E34", "#17084A", "#FF6710", "#FFD166", "#FFFFFF"];

/**
 * A celebratory confetti burst — a center pop plus two side cannons — fired when
 * a certificate (or a batch) is printed. Respects the user's reduced-motion
 * preference via canvas-confetti's built-in guard.
 */
export const celebrate = (): void => {
  const defaults = {
    colors: BRAND_COLORS,
    ticks: 90,
    zIndex: 9999,
    disableForReducedMotion: true,
  };

  confetti({
    ...defaults,
    particleCount: 90,
    spread: 75,
    startVelocity: 45,
    origin: { x: 0.5, y: 0.65 },
  });
  confetti({
    ...defaults,
    particleCount: 40,
    angle: 60,
    spread: 60,
    origin: { x: 0, y: 0.8 },
  });
  confetti({
    ...defaults,
    particleCount: 40,
    angle: 120,
    spread: 60,
    origin: { x: 1, y: 0.8 },
  });
};
